<template>
  <div>
    <b-navbar fixed-top></b-navbar>
    <section class="main-content columns">
      <div class="container column is-10">
        <nuxt />
        .
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/shared/layout/Footer'

export default {
  components: {
    Footer,
  },
}
</script>

<style scoped>
section {
  padding: 1rem 1.5rem;
}
.main-content {
  background-color: white;
}

footer {
  margin-top: 50px;
}
</style>
